import { render, staticRenderFns } from "./SettingDetail.vue?vue&type=template&id=01683cc0&scoped=true&"
import script from "./SettingDetail.vue?vue&type=script&lang=js&"
export * from "./SettingDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingDetail.vue?vue&type=style&index=0&id=01683cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01683cc0",
  null
  
)

export default component.exports